/**
 * Arena Pet Bowl Set 图片切换系统
 * 直接从 CDN 加载预渲染的组合图片
 * 命名规则: bowl2_top_{TopColor}_{TopFinish}_bottom_{BottomColor}_{BottomFinish}.jpg
 */

(function() {
  'use strict';

  console.log('🥣 [ArenaBowl] 脚本开始加载...');

  // ========== 配置 ==========
  const PRODUCT_NAME = 'Arena Pet Bowl Set';
  const CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const CDN_VERSION = '?v=1764178371';

  // 颜色名称映射
  const COLOR_MAP = {
    'White': 'white',
    'Black': 'black',
    'Pink': 'pink',
    'Baby Blue': 'babyblue',
    'BabyBlue': 'babyblue',
    'Yellow': 'yellow',
    'Cyan': 'cyan',
    'Navy Blue': 'navyblue',
    'NavyBlue': 'navyblue',
    'Navy': 'navyblue',  // Globo插件使用的简写
    'Orange': 'orange',
    'Green': 'green',
    'Purple': 'purple',
    'PurpleHaze': 'purple',  // Globo插件使用的变体
    'Red': 'red',
    'Brown': 'brown'
  };

  // ========== 工具函数 ==========
  
  // 防抖计时器
  let updateTimer = null;
  // 当前正在更新的标记
  let isUpdating = false;
  // 上次更新的组合（用于避免重复更新）
  let lastUpdateKey = '';

  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  /** 桌面 PDP 2×2：CDN 合成图只应改右上变体格，不能用「可视面积最大」否则会稳定选中左上格 */
  function isDesktopPdpWith2x2() {
    const main = document.querySelector('.main-image');
    if (!main || !main.querySelector('.product-media-2x2')) return false;
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function shouldRun() {
    console.log('🥣 [ArenaBowl] shouldRun() 检查中...');
    
    // Customize 页面
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = selectedOption.value;
          console.log('🥣 [ArenaBowl] Customize 选中:', selectedName, '| Handle:', selectedHandle);
          
          if (selectedName.includes('Arena Pet Bowl') || selectedHandle.includes('arena')) {
            console.log('✅ [ArenaBowl] Customize 页面匹配！');
            return true;
          }
        }
      }
      console.log('⏭️ [ArenaBowl] Customize 页面不匹配');
      return false;
    }

    // 产品页面
    const url = window.location.href.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    console.log('🥣 [ArenaBowl] 产品页 URL:', url);
    console.log('🥣 [ArenaBowl] 产品页 Title:', pageTitle);
    
    if ((url.includes('arena') && url.includes('bowl')) || pageTitle.includes('arena pet bowl')) {
      console.log('✅ [ArenaBowl] 产品页面匹配！');
      return true;
    }
    // 🎯 SEO 改动：产品 handle 可能改为 roman-column-bowl、dual-color-arena 等，需兼容
    if (url.includes('roman-column-bowl') || url.includes('dual-color-arena') || url.includes('arena-dual') || url.includes('arena-elevated')) {
      console.log('✅ [ArenaBowl] 产品页面匹配（SEO handle）！');
      return true;
    }

    console.log('⏭️ [ArenaBowl] 不是 Arena Bowl 产品');
    return false;
  }

  function normalizeColor(name) {
    if (!name) return null;
    if (COLOR_MAP[name]) return COLOR_MAP[name];
    
    const normalized = name.toLowerCase().replace(/\s+/g, '');
    for (const key in COLOR_MAP) {
      if (key.toLowerCase().replace(/\s+/g, '') === normalized) {
        return COLOR_MAP[key];
      }
    }
    return normalized;
  }

  function parseFinishValue(value) {
    if (!value) return { top: 'glossy', bottom: 'glossy' };

    // 🎯 清除箭头符号和emoji（Globo插件可能添加的）
    const cleanValue = value.replace(/⬆️|⬇️|↑|↓|🔺|🔻/g, '').trim();
    
    const parts = cleanValue.toLowerCase().split('+');
    let topFinish = 'glossy';
    let bottomFinish = 'glossy';

    if (parts.length >= 2) {
      topFinish = parts[0].trim().includes('matte') ? 'matte' : 'glossy';
      bottomFinish = parts[1].trim().includes('matte') ? 'matte' : 'glossy';
    } else {
      const finish = cleanValue.toLowerCase().includes('matte') ? 'matte' : 'glossy';
      topFinish = finish;
      bottomFinish = finish;
    }

    return { top: topFinish, bottom: bottomFinish };
  }

  function generateImageUrl(options) {
    const topColor = normalizeColor(options.topColor);
    const bottomColor = normalizeColor(options.bottomColor);
    const finishes = parseFinishValue(options.finish);

    if (!topColor || !bottomColor) {
      console.warn('⚠️ [ArenaBowl] 颜色信息不完整', options);
      return null;
    }

    const filename = `bowl2_top_${topColor}_${finishes.top}_bottom_${bottomColor}_${finishes.bottom}.jpg`;
    const url = `${CDN_BASE_URL}${filename}${CDN_VERSION}`;
    
    console.log('🥣 [ArenaBowl] 生成URL:', url);
    return url;
  }

  function getOptionValue(index) {
    if (isCustomizePage()) {
      // 尝试0: 优先用 custom-builder 同步的全局选项（与 MuseStand 一致，避免 DOM 时序问题）
      if (typeof window.selectedOptions !== 'undefined' && window.selectedOptions && index < window.selectedOptions.length) {
        const val = window.selectedOptions[index];
        if (val) {
          console.log('[ArenaBowl-DEBUG] getOptionValue(' + index + ') 来自 selectedOptions:', val);
          return val;
        }
      }
      // 尝试1: color-swatch
      const swatch = document.querySelector(`.color-swatch[data-index="${index}"].selected`);
      if (swatch) {
        console.log('[ArenaBowl-DEBUG] getOptionValue(' + index + ') 来自 DOM .color-swatch:', swatch.dataset.value);
        return swatch.dataset.value;
      }
      // 尝试2: text-option
      const textBtn = document.querySelector(`.text-option[data-index="${index}"].selected`);
      if (textBtn) {
        console.log('[ArenaBowl-DEBUG] getOptionValue(' + index + ') 来自 DOM .text-option:', textBtn.dataset.value);
        return textBtn.dataset.value;
      }
      // 尝试3: select下拉框
      const select = document.querySelector(`select[data-index="${index}"]`);
      if (select && select.value) return select.value;
      console.warn('[ArenaBowl-DEBUG] getOptionValue(' + index + ') 未取到值，返回 null');
      return null;
    } else {
      // 尝试1: Globo插件选择器
      const globo = document.querySelector(`input[name="globo-option-${index}"]:checked`);
      if (globo) return globo.value;
      
      // 尝试2: 标准Shopify选择器（选项从1开始）
      const idx = index + 1;
      const std = document.querySelector(`input[name*="option${idx}"]:checked, input[name*="Option${idx}"]:checked`);
      if (std) return std.value;
      
      // 尝试3: select下拉框
      const stdSelect = document.querySelector(`select[name*="option${idx}"], select[name*="Option${idx}"]`);
      if (stdSelect && stdSelect.value) return stdSelect.value;
    }

    return null;
  }

  // ========== Finish可用性控制 ==========
  
  /**
   * 更新Finish选项的可用状态
   */
  function updateFinishAvailability() {
    const topColor = getOptionValue(0);
    const bottomColor = getOptionValue(1);
    
    if (!topColor || !bottomColor) {
      console.log('🎯 [ArenaBowl] 颜色未完全选择，跳过Finish更新');
      return;
    }
    
    console.log('🎯 [ArenaBowl] 更新Finish可用性:', { topColor, bottomColor });
    
    // 检查ArenaFinishConfig是否已加载
    if (typeof window.ArenaFinishConfig === 'undefined') {
      console.warn('⚠️ [ArenaBowl] ArenaFinishConfig未加载');
      return;
    }
    
    // 🎯 根据页面类型选择不同的选择器
    let finishElements = [];
    
    if (isCustomizePage()) {
      // Customize页面：使用 .text-option
      const buttons = document.querySelectorAll('.text-option[data-index="2"]');
      finishElements = Array.from(buttons).map(btn => ({
        element: btn,
        value: btn.dataset.value,
        type: 'customize'
      }));
      console.log(`🎯 [ArenaBowl] Customize页面，找到 ${finishElements.length} 个Finish选项`);
    } else {
      // 产品页面：支持多种插件
      // 🎯 优先查找 Globo 插件的 Finish 选项（index=2）
      let radioButtons = document.querySelectorAll('input[name="globo-option-2"]');
      
      // 如果没找到Globo，查找标准Shopify的option3
      if (radioButtons.length === 0) {
        radioButtons = document.querySelectorAll('input[name*="option3"], input[name*="Option3"]');
      }
      
      finishElements = Array.from(radioButtons).map(radio => {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        return {
          element: radio,
          label: label,
          value: radio.value,
          type: 'product'
        };
      });
      console.log(`🎯 [ArenaBowl] 产品页面，找到 ${finishElements.length} 个Finish选项`);
    }
    
    if (finishElements.length === 0) {
      console.log('⏭️ [ArenaBowl] 未找到Finish按钮');
      return;
    }
    
    let hasAvailableOption = false;
    let firstAvailableElement = null;
    
    finishElements.forEach(item => {
      const finishValue = item.value;
      const finishes = parseFinishValue(finishValue);
      
      // 检查这个组合是否可用
      const isAvailable = window.ArenaFinishConfig.isFinishCombinationAvailable(
        topColor, 
        bottomColor, 
        finishes.top, 
        finishes.bottom
      );
      
      console.log(`  ${finishValue}: ${isAvailable ? '✅可用' : '❌不可用'}`);
      
      if (item.type === 'customize') {
        // Customize页面：直接操作按钮
        const btn = item.element;
        if (isAvailable) {
          btn.classList.remove('disabled');
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.style.pointerEvents = 'auto';
          
          hasAvailableOption = true;
          if (!firstAvailableElement) firstAvailableElement = item;
        } else {
          btn.classList.add('disabled');
          btn.classList.remove('selected');
          btn.style.opacity = '0.3';
          btn.style.cursor = 'not-allowed';
          btn.style.pointerEvents = 'none';
        }
      } else {
        // 产品页面：操作radio和label
        const radio = item.element;
        const label = item.label;
        
        if (isAvailable) {
          // 可用：移除禁用类和样式
          radio.classList.remove('is-unavailable');
          radio.disabled = false;
          if (label) {
            label.style.opacity = '1';
            label.style.cursor = 'pointer';
            label.style.pointerEvents = 'auto';
          }
          
          hasAvailableOption = true;
          if (!firstAvailableElement) firstAvailableElement = item;
        } else {
          // 不可用：添加禁用类和样式
          radio.classList.add('is-unavailable');
          radio.disabled = true;
          if (label) {
            label.style.opacity = '0.3';
            label.style.cursor = 'not-allowed';
            label.style.pointerEvents = 'none';
          }
        }
      }
    });
    
    // 如果当前选中的不可用，自动切换到第一个可用的
    const currentFinish = getOptionValue(2);
    if (currentFinish) {
      const currentFinishes = parseFinishValue(currentFinish);
      const isCurrentAvailable = window.ArenaFinishConfig.isFinishCombinationAvailable(
        topColor, 
        bottomColor, 
        currentFinishes.top, 
        currentFinishes.bottom
      );
      
      if (!isCurrentAvailable && firstAvailableElement) {
        console.log('🔄 [ArenaBowl] 当前Finish不可用，自动切换到:', firstAvailableElement.value);
        if (firstAvailableElement.type === 'customize') {
          firstAvailableElement.element.click();
        } else {
          firstAvailableElement.element.click();
        }
      }
    } else if (firstAvailableElement) {
      // 如果没有选中任何finish，自动选择第一个可用的
      console.log('🔄 [ArenaBowl] 自动选择第一个可用Finish:', firstAvailableElement.value);
      firstAvailableElement.element.click();
    }
  }
  
  function updateImage() {
    console.log('[ArenaBowl-DEBUG] update() 被调用，300ms 后执行 doUpdateImage');
    // 🎯 防抖：取消之前的更新请求
    if (updateTimer) {
      clearTimeout(updateTimer);
      console.log('⏭️ [ArenaBowl] 取消之前的更新请求（防抖）');
    }
    
    // 延迟执行，避免多次触发
    updateTimer = setTimeout(doUpdateImage, 300);
  }
  
  function doUpdateImage() {
    if (!shouldRun()) {
      console.log('[ArenaBowl-DEBUG] 跳过原因: shouldRun() 返回 false（当前页面/产品不是 Arena Bowl）');
      return;
    }
    
    // 🎯 如果正在更新中，跳过
    if (isUpdating) {
      console.log('[ArenaBowl-DEBUG] 跳过原因: 正在更新中 isUpdating=true');
      return;
    }
    
    console.log('🥣 [ArenaBowl] ========== 开始更新图片 ==========');
    
    const topColor = getOptionValue(0);
    const bottomColor = getOptionValue(1);
    const finish = getOptionValue(2);
    
    console.log('🥣 [ArenaBowl] 当前选项:', { 
      topColor, 
      bottomColor, 
      finish,
      页面类型: isCustomizePage() ? 'Customize' : 'Product'
    });
    
    // 🎯 生成唯一标识，检查是否与上次相同
    const updateKey = `${topColor}_${bottomColor}_${finish}`;
    if (updateKey === lastUpdateKey) {
      console.log('[ArenaBowl-DEBUG] 跳过原因: 选项与上次相同 updateKey=', updateKey);
      return;
    }
    
    if (!topColor || !bottomColor || !finish) {
        console.warn('[ArenaBowl-DEBUG] 跳过原因: 选项不完整', { topColor, bottomColor, finish });
        lastUpdateKey = ''; // 重置
        
        // 🎯 如果在 Customize 页面且有 variant 图片，显示 variant 图片
        if (isCustomizePage() && window.currentArenaBowlVariant) {
          const variant = window.currentArenaBowlVariant;
          if (variant.featured_image && variant.featured_image.src) {
            console.log('✅ [ArenaBowl] 使用 Variant 图片作为默认图');
            const img = document.querySelector('.custom-builder .main-image');
            if (img) {
              img.src = variant.featured_image.src;
            }
          }
        }
        
        return;
    }

    const url = generateImageUrl({ topColor, bottomColor, finish });
    if (!url) {
      console.error('❌ [ArenaBowl] URL生成失败');
      lastUpdateKey = ''; // 重置
      return;
    }
    
    // 🎯 标记为正在更新
    isUpdating = true;
    lastUpdateKey = updateKey;
    
    console.log('✅ [ArenaBowl] CDN URL:', url);

    // 查找主图
    console.log('🔍 [ArenaBowl] 开始查找主图片元素...');
    let mainImages = [];
    
    if (isCustomizePage()) {
        const img = document.querySelector('.custom-builder .main-image');
        if (img) {
          console.log('✅ [ArenaBowl] Customize页面找到主图:', img.className);
          mainImages.push(img);
        } else {
          console.error('❌ [ArenaBowl] Customize页面未找到 .main-image');
        }
    } else {
        // 产品页面：使用"最大可视面积"策略（从 EasyGo 借鉴）；2×2 时强制只用右上变体格
        console.log('🔍 [ArenaBowl] 产品页面，查找主图目标元素');

        let maxVisibleArea = 0;
        let bestImage = null;

        if (isDesktopPdpWith2x2()) {
          const cell = document.querySelector('.product-media-2x2 .media-2x2-cell--variant');
          let vImg = cell && cell.querySelector('img');
          if (cell && !vImg) {
            vImg = document.createElement('img');
            vImg.alt = '';
            cell.appendChild(vImg);
          }
          if (vImg) {
            bestImage = vImg;
            console.log('✅ [ArenaBowl] 桌面 2×2：CDN 只更新右上变体格（跳过可视面积策略）');
          }
        }

        const allImages = document.querySelectorAll('img');
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        console.log(`🔍 [ArenaBowl] 扫描 ${allImages.length} 张图片...`);

        // 🎯 策略1: 优先查找 layer-image.top-layer（兼容旧的图层系统）
        if (!bestImage) {
          const topLayer = document.querySelector('.layer-image.top-layer, img.layer-image[class*="top"]');
          if (topLayer && topLayer.offsetWidth > 200 && topLayer.offsetHeight > 200) {
            const style = window.getComputedStyle(topLayer);
            if (style.opacity !== '0' && style.visibility !== 'hidden' && style.display !== 'none') {
              console.log('✅ [ArenaBowl] 策略1成功 - 找到 layer-image.top-layer:', topLayer.className);
              bestImage = topLayer;
            }
          }
        }

        // 🎯 策略2: 如果没找到 layer，使用"最大可视面积"
        if (!bestImage) {
            console.log('🔍 [ArenaBowl] 策略1失败，使用策略2：计算可视面积...');
            
            allImages.forEach((img, idx) => {
                // 快速过滤小图标
                if (img.width < 200 || img.height < 200) return;
                
                const rect = img.getBoundingClientRect();
                
                // 计算与视口的交叉区域
                const intersectionLeft = Math.max(0, rect.left);
                const intersectionTop = Math.max(0, rect.top);
                const intersectionRight = Math.min(viewportWidth, rect.right);
                const intersectionBottom = Math.min(viewportHeight, rect.bottom);
                
                if (intersectionRight > intersectionLeft && intersectionBottom > intersectionTop) {
                    const visibleWidth = intersectionRight - intersectionLeft;
                    const visibleHeight = intersectionBottom - intersectionTop;
                    const visibleArea = visibleWidth * visibleHeight;
                    
                    const style = window.getComputedStyle(img);
                    const isVisible = style.opacity !== '0' && 
                                     style.visibility !== 'hidden' && 
                                     style.display !== 'none';
                    
                    if (isVisible && visibleArea > maxVisibleArea) {
                        maxVisibleArea = visibleArea;
                        bestImage = img;
                        
                        if (idx < 10) {  // 只打印前10个候选
                            console.log(`  候选[${idx}]: 可视面积=${Math.round(visibleArea)}px², class="${img.className}"`);
                        }
                    }
                }
            });
            
            if (bestImage) {
                console.log(`✅ [ArenaBowl] 策略2成功 - 找到可视面积最大的图片 (${Math.round(maxVisibleArea)}px²)`);
                console.log(`   class: "${bestImage.className}", 尺寸: ${bestImage.width}x${bestImage.height}`);
            } else {
                console.error('❌ [ArenaBowl] 策略2也失败 - 未找到任何可见主图');
            }
        }
        
        if (bestImage) {
            mainImages.push(bestImage);
        }
    }

    if (mainImages.length === 0) {
        console.error('[ArenaBowl-DEBUG] 跳过原因: 未找到 .custom-builder .main-image 主图元素');
        console.log('💡 [ArenaBowl] 提示：请检查页面DOM结构');
        isUpdating = false; // 重置标记
        return;
    }
    
    const img = mainImages[0];
    console.log('🔧 [ArenaBowl] 准备更新图片元素:');
    console.log('   图片class:', img.className);
    console.log('   当前 src:', img.src);
    console.log('   目标 src:', url);
    console.log('   图片可见:', img.offsetWidth > 0 && img.offsetHeight > 0);
    console.log('   图片尺寸:', img.offsetWidth, 'x', img.offsetHeight);
    
    // 🎯 调试：列出页面上所有大尺寸图片
    const debugAllImages = document.querySelectorAll('img');
    const visibleLargeImages = Array.from(debugAllImages).filter(i => 
        i.offsetWidth > 200 && i.offsetHeight > 200 &&
        window.getComputedStyle(i).display !== 'none'
    );
    console.log(`🔍 [ArenaBowl] 页面上共有 ${visibleLargeImages.length} 个可见的大尺寸图片`);
    visibleLargeImages.forEach((debugImg, idx) => {
        console.log(`   图片[${idx}]: class="${debugImg.className}", 是否为目标=${debugImg === img}`);
    });
    
    if (img.src === url && !img.hasAttribute('srcset')) {
        console.log('⏭️ [ArenaBowl] 图片未变化，跳过更新');
        isUpdating = false; // 重置标记
        return;
    }
    
    console.log('🥣 [ArenaBowl] 开始更新图片...');
    
    // 🎯 关键修复：隐藏所有可能叠加的图片
    console.log('🔧 [ArenaBowl] 开始清理可能叠加的图片...');
    
    if (isCustomizePage()) {
        // Customize页面：特殊处理
        console.log('🔧 [ArenaBowl] Customize页面模式 - 隐藏所有非目标图片');
        
        // 1. 隐藏 .product-image 容器内的所有其他图片
        const imageContainer = document.querySelector('.custom-builder .product-image');
        if (imageContainer) {
            const allImgsInContainer = imageContainer.querySelectorAll('img');
            console.log(`   找到容器内 ${allImgsInContainer.length} 个图片`);
            allImgsInContainer.forEach((containerImg, idx) => {
                if (containerImg !== img) {
                    containerImg.style.display = 'none';
                    containerImg.style.visibility = 'hidden';
                    console.log(`   🚫 隐藏容器内图片[${idx}]: ${containerImg.className}`);
                }
            });
        }
        
        // 2. 隐藏所有 layer-image（如果图层脚本添加了）
        const allLayerImages = document.querySelectorAll('.custom-builder .layer-image');
        if (allLayerImages.length > 0) {
            console.log(`   找到 ${allLayerImages.length} 个图层图片`);
            allLayerImages.forEach((layerImg, idx) => {
                if (layerImg !== img) {
                    layerImg.style.display = 'none';
                    layerImg.style.visibility = 'hidden';
                    console.log(`   🚫 隐藏图层[${idx}]: ${layerImg.className}`);
                }
            });
        }
        
        // 3. 🎯 激进策略：隐藏 custom-builder 内除目标外的所有大图片
        const allBuilderImages = document.querySelectorAll('.custom-builder img');
        let hiddenCount = 0;
        allBuilderImages.forEach((builderImg) => {
            if (builderImg !== img && builderImg.offsetWidth > 100 && builderImg.offsetHeight > 100) {
                builderImg.style.display = 'none';
                builderImg.style.visibility = 'hidden';
                builderImg.style.opacity = '0';
                hiddenCount++;
            }
        });
        if (hiddenCount > 0) {
            console.log(`   🚫 激进策略：隐藏了 ${hiddenCount} 个额外的图片`);
        }
        
        // 4. 确保目标图片可见并置顶
        img.style.display = 'block';
        img.style.visibility = 'visible';
        img.style.opacity = '1';
        img.style.position = 'relative';
        img.style.zIndex = '999';
        console.log('   ✅ 确保目标图片(.main-image)可见并置顶');
        
    } else {
        // 产品页面：原有逻辑（2×2 只改右上格时不要批量隐藏其它媒体，避免误伤四宫格）
        const skipBulkHide = isDesktopPdpWith2x2() && img.closest && img.closest('.media-2x2-cell--variant');
        if (skipBulkHide) {
          console.log('🔧 [ArenaBowl] 桌面 2×2 变体格模式 — 跳过批量隐藏图层/产品图');
        } else {
          console.log('🔧 [ArenaBowl] 产品页面模式 - 隐藏图层和产品图片');

          const allLayerImages = document.querySelectorAll('.layer-image');
          if (allLayerImages.length > 0) {
            console.log(`   找到 ${allLayerImages.length} 个图层图片`);
            allLayerImages.forEach((layerImg, idx) => {
              if (layerImg !== img) {
                layerImg.style.display = 'none';
                console.log(`   🚫 隐藏图层[${idx}]: ${layerImg.className}`);
              } else {
                console.log(`   ✅ 保留目标图层[${idx}]: ${layerImg.className}`);
              }
            });
          }

          const allProductImages = document.querySelectorAll('.product__media-item img, .product-single__photo img, .product-gallery img');
          if (allProductImages.length > 0) {
            console.log(`   找到 ${allProductImages.length} 个产品图片容器`);
            allProductImages.forEach((prodImg, idx) => {
              if (prodImg !== img && prodImg.offsetWidth > 200) {
                const parent = prodImg.closest('.product__media-item, .product-single__photo');
                if (parent && parent !== img.closest('.product__media-item, .product-single__photo')) {
                  parent.style.display = 'none';
                  console.log(`   🚫 隐藏产品图片容器[${idx}]`);
                } else if (prodImg !== img) {
                  prodImg.style.display = 'none';
                  console.log(`   🚫 隐藏产品图片[${idx}]`);
                }
              }
            });
          }
        }
    }
    
    // 先预加载图片，确保存在
    const testImg = new Image();
    testImg.onload = function() {
        console.log('✅ [ArenaBowl] CDN图片预加载成功');
        
        // 启动保护机制
        startProtectingImage(img, url);
        
        // 淡出效果
        img.style.transition = 'opacity 0.3s ease';
        img.style.opacity = '0.5';
        
        setTimeout(() => {
            // 清理响应式图片属性
            if (img.hasAttribute('srcset')) {
              console.log('🔧 [ArenaBowl] 移除 srcset');
              img.removeAttribute('srcset');
            }
            if (img.hasAttribute('sizes')) {
              console.log('🔧 [ArenaBowl] 移除 sizes');
              img.removeAttribute('sizes');
            }
            if (img.hasAttribute('data-src')) img.removeAttribute('data-src');
            if (img.hasAttribute('data-srcset')) img.removeAttribute('data-srcset');
            if (img.loading === 'lazy') {
              console.log('🔧 [ArenaBowl] 禁用懒加载');
              img.loading = 'eager';
            }
            
            // 更新 src
            img.src = url;
            
            // 🎯 确保当前图片可见
            img.style.display = '';
            img.style.visibility = 'visible';
            img.style.opacity = '1';
            
            // 强制重绘
            img.offsetHeight;
            
            console.log('✅ [ArenaBowl] 图片已更新');
            console.log('   新 src:', img.src);
            console.log('   srcset已移除:', !img.hasAttribute('srcset'));
            
            // 🎯 重置更新标记
            isUpdating = false;
            
            // 验证更新是否成功
            setTimeout(() => {
              if (img.src === url) {
                console.log('✅ [ArenaBowl] 验证通过：图片确实已更新');
                console.log('🥣 [ArenaBowl] ========== 更新完成 ==========');
              } else {
                console.error('❌ [ArenaBowl] 验证失败：图片被还原为', img.src);
                // 再次尝试
                img.src = url;
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
              }
            }, 500);
        }, 150);
    };
    
    testImg.onerror = function() {
        console.error('❌ [ArenaBowl] CDN图片加载失败:', url);
        console.log('💡 [ArenaBowl] 请检查：');
        console.log('   1. 图片是否已上传到CDN');
        console.log('   2. 文件名是否正确');
        console.log('   3. URL是否可访问');
        
        // 🎯 重置更新标记
        isUpdating = false;
    };
    
    console.log('🔧 [ArenaBowl] 预加载CDN图片...');
    testImg.src = url;
  }
  
  let imageObserver = null;
  function startProtectingImage(img, targetUrl) {
      if (imageObserver) imageObserver.disconnect();
      
      let isRestoring = false; // 防止无限循环
      
      imageObserver = new MutationObserver((mutations) => {
          if (isRestoring) return; // 如果正在还原，跳过
          
          mutations.forEach(m => {
              if (m.type === 'attributes' && m.attributeName === 'src') {
                  if (img.src !== targetUrl) {
                      console.log('🛡️ [ArenaBowl] 检测到src被修改，还原图片');
                      isRestoring = true;
                      img.src = targetUrl;
                      img.removeAttribute('srcset');
                      setTimeout(() => { isRestoring = false; }, 100);
                  }
              }
              
              if (m.type === 'attributes' && m.attributeName === 'srcset') {
                  if (img.hasAttribute('srcset')) {
                      console.log('🛡️ [ArenaBowl] 检测到srcset被添加，移除');
                      isRestoring = true;
                      img.removeAttribute('srcset');
                      setTimeout(() => { isRestoring = false; }, 100);
                  }
              }
          });
      });
      
      imageObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
      console.log('🛡️ [ArenaBowl] 图片保护已启动');
  }
  
  function stopProtectingImage() {
      if (imageObserver) {
          imageObserver.disconnect();
          imageObserver = null;
          console.log('🛡️ [ArenaBowl] 图片保护已停止');
      }
  }

  function init() {
    console.log('🥣 [ArenaBowl] ========== 初始化开始 ==========');
    
    if (!shouldRun()) {
      console.log('⏭️ [ArenaBowl] 初始化跳过（不是目标产品）');
      return;
    }
    
    console.log('✅ [ArenaBowl] 确认为Arena Bowl产品，开始初始化...');
    console.log('   页面类型:', isCustomizePage() ? 'Customize页面' : '产品页面');
    console.log('   页面URL:', window.location.href);
    
    // 🎯 防止重复绑定：检查是否已经绑定过
    if (!document.body.dataset.arenaBowlBound) {
        document.body.dataset.arenaBowlBound = 'true';
        
        // 绑定点击事件（使用事件委托）
        document.body.addEventListener('click', function(e) {
            if (!shouldRun()) return; // 只在Arena Bowl产品时响应
            
            if (e.target.closest('.color-swatch') || 
                e.target.closest('.text-option') || 
                e.target.matches('input[type="radio"]') ||
                e.target.matches('label[for*="option"]')) {
                console.log('🥣 [ArenaBowl] 检测到选项点击');
                
                // 如果是颜色选项(index 0或1)，更新Finish可用性
                const target = e.target.closest('.color-swatch') || e.target.closest('.text-option');
                if (target && target.dataset.index) {
                  const optionIndex = parseInt(target.dataset.index);
                  if (optionIndex === 0 || optionIndex === 1) {
                    console.log('🎯 [ArenaBowl] 颜色选项变化，延迟更新Finish可用性');
                    setTimeout(updateFinishAvailability, 100);
                  }
                }
                
                updateImage(); // 直接调用（已有防抖）
            }
        }, true); // 使用捕获阶段，确保最先触发
        console.log('✅ [ArenaBowl] 已绑定点击事件监听器');
        
        // 绑定change事件
        document.body.addEventListener('change', function(e) {
            if (!shouldRun()) return; // 只在Arena Bowl产品时响应
            
            if (e.target.matches('select') || e.target.matches('input[type="radio"]')) {
                console.log('🥣 [ArenaBowl] 检测到选项变化:', e.target.value);
                
                // 检查是否是颜色选项
                const name = e.target.name || '';
                // 🎯 产品页面: option1-option, option2-option (从1开始)
                // 🎯 Customize页面: option0, option1 (从0开始) 或 globo-option-0, globo-option-1
                if (name.includes('option1') || name.includes('option2') ||
                    name.includes('Option1') || name.includes('Option2') ||
                    name.includes('option0') || name.includes('Option0') ||
                    name.includes('globo-option-0') || name.includes('globo-option-1')) {
                  console.log('🎯 [ArenaBowl] 颜色选项变化，延迟更新Finish可用性');
                  setTimeout(updateFinishAvailability, 100);
                }
                
                updateImage(); // 直接调用（已有防抖）
            }
        }, true); // 使用捕获阶段
        console.log('✅ [ArenaBowl] 已绑定change事件监听器');
    } else {
        console.log('⏭️ [ArenaBowl] 事件监听器已存在，跳过绑定');
    }
    
    // Customize页面：监听选项区域变化（仅限首次加载）
    if (isCustomizePage()) {
        const wrapper = document.getElementById('product-option-groups');
        if (wrapper) {
            console.log('✅ [ArenaBowl] 找到选项容器，启动MutationObserver（仅首次）');
            let hasInitialized = false;
            const obs = new MutationObserver((mutations) => {
                // 🎯 只在首次检测到选项添加时触发一次
                if (!hasInitialized && shouldRun()) {
                    const hasNewOptions = mutations.some(m => 
                        m.addedNodes.length > 0 && 
                        Array.from(m.addedNodes).some(n => 
                            n.classList && (n.classList.contains('color-swatch') || n.classList.contains('text-option'))
                        )
                    );
                    
                    if (hasNewOptions) {
                        console.log('👀 [ArenaBowl] 检测到选项首次加载');
                        hasInitialized = true;
                        setTimeout(() => {
                            updateFinishAvailability();
                            updateImage();
                        }, 500);
                    }
                }
            });
            obs.observe(wrapper, { childList: true, subtree: true });
        } else {
            console.warn('⚠️ [ArenaBowl] 未找到 #product-option-groups 容器');
        }
        
        // 监听产品切换
        const productSelect = document.getElementById('product-select');
        if (productSelect) {
            productSelect.addEventListener('change', function() {
                console.log('🔄 [ArenaBowl] 检测到产品切换');
                setTimeout(() => {
                    if (shouldRun()) {
                        console.log('🔄 [ArenaBowl] 切换到Arena Bowl，重新初始化');
                        setTimeout(() => {
                            updateFinishAvailability();
                            updateImage();
                        }, 500);
                    }
                }, 300);
            });
            console.log('✅ [ArenaBowl] 已绑定产品切换监听器');
        }
    }

    // 初始更新（延迟执行，确保DOM完全加载）
    console.log('🔧 [ArenaBowl] 1秒后执行首次图片更新...');
    setTimeout(() => {
        console.log('🔧 [ArenaBowl] 执行首次图片更新');
        updateFinishAvailability();
        updateImage();
    }, 1000);
    
    console.log('✅ [ArenaBowl] 初始化完成');
    console.log('🥣 [ArenaBowl] ========== 初始化结束 ==========');
  }
  
  window.ArenaBowl = {
    update: updateImage,
    updateFinishAvailability: updateFinishAvailability,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 500);
  }

  console.log('🥣 [ArenaBowl] 脚本加载完成，等待初始化');

})();
